<template>
  <div class="container">
    <div class="row mt-5">
      <div class="col text-center">
        <h3 class="text-decoration-underline">Local</h3>
      </div>
    </div>
    <!-- Local -->
    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Marc Joanisse from
            <a href="https://publish.uwo.ca/~marcj/" target="_blank">
              The Language, Reading and Cognitive Neurosicence Lab at Western University
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="raw/marc_joanisse.jpeg" class="img-fluid" alt="Marc Joanisse" width="200" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Ryan Stevenson from
            <a href="https://sensorylab.ca/" target="_blank">
              The sensory perception research lab at Western University
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="raw/ryan_stevenson.jpeg" class="img-fluid" alt="Ryan Stevenson" width="300" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Jeff Tennant from
            <a href="https://www.uwo.ca/french/people/faculty/tennant.html" target="_blank">
              The Department of French Studies at Western University
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="raw/jeff_tennant.jpeg" class="img-fluid" alt="Jeff Tennant" width="200" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row mt-5">
      <div class="col text-center">
        <h3 class="text-decoration-underline">National</h3>
      </div>
    </div>
    <!-- National -->
    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Simon Overduin from
            <a href="https://www.syngli.com/" target="_blank">
              Syngli Inc
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="raw/simon_overduin.jpg" class="img-fluid" alt="Simon Overduin" width="300" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Veronica Whitford from
            <a href="https://www.veronicawhitford.com/team" target="_blank">
              Veronica Whitford lab at the University of New Brunswick
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="raw/veronica_whitford.jpeg" class="img-fluid" alt="Veronica Whitford" width="300" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row mt-5">
      <div class="col text-center">
        <h3 class="text-decoration-underline">International</h3>
      </div>
    </div>
    <!-- International -->
    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Rajiv Rao from
            <a href="https://spanport.wisc.edu/staff/rao-rajiv-g/" target="_blank">
              University of Wisconsin-Madison
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="raw/rajiv_rao.png" class="img-fluid" alt="Rajiv Rao" width="300" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Laura Spinu from
            <a href="https://lspinu.commons.gc.cuny.edu/" target="_blank">
              CUNY Kingsborough Community College
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="crop/laura_spinu.png" class="img-fluid" alt="Laura Spinu" width="300" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Martha Black from
            <a href="https://www.lpl-aix.fr/contact/black-martha/" target="_blank">
              Laboratoire Parole et Langage at Aix-Marseille University
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="raw/martha_black.jpg" class="img-fluid" alt="Martha Black" width="300" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row g-4 mt-4 mb-5 m-2">
      <div class="col-md-12">
        <div class="card-body">
          <p class="card-text text-center fs-4 mb-4">
            Vanina Machado from
            <a href="https://vaninamachado.com/" target="_blank">
              California State University Channel Islands
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </p>

          <div class="row">
            <div class="col-md-4 offset-md-4">
              <p class="card-text text-center fs-5 mb-4">
                <img src="crop/vanina_machado.jpg" class="img-fluid" alt="Vanina Machado" width="270" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<style scoped>
img {
  border-radius: 35px;
}
</style>  